import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import baseURL from '../config';
import Navbar from '../Navbar/Navbar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { IconButton, Tooltip } from '@mui/material';

const AllAdminCrewing = () => {
  const [crewingAgents, setCrewingAgents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openModal, setOpenModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [invoiceData, setInvoiceData] = useState({
    JoinerWithCrewWelfare: '',
    RejionerWithCrewWelfare: '',
    JoinerWithoutCrewWelfare: '',
    RejionerWithoutCrewWelfare: '',
  });
  const navigate = useNavigate();
  const creatorId = localStorage.getItem("user id");
  const [openBankModal, setOpenBankModal] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    bankAdress: '',
  });

  useEffect(() => {
    const fetchCrewingAgents = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${baseURL}/api/getcrewingAgentDetails`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCrewingAgents(response.data);
      } catch (error) {
        console.error('Error fetching crewing agents:', error);
      }
    };
    fetchCrewingAgents();
  }, []);

  const handleOpenModal = (agentId) => {
    setSelectedAgent(agentId);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setInvoiceData({
      JoinerWithCrewWelfare: '',
      RejionerWithCrewWelfare: '',
      JoinerWithoutCrewWelfare: '',
      RejionerWithoutCrewWelfare: '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
 
    try {
      const payload = {
        crewingAgentId: selectedAgent, // Passing selected Agent ID
        JoinerWithCrewWelfare: invoiceData.JoinerWithCrewWelfare,
        RejionerWithCrewWelfare: invoiceData.RejionerWithCrewWelfare,
        JoinerWithoutCrewWelfare: invoiceData.JoinerWithoutCrewWelfare,
        RejionerWithoutCrewWelfare: invoiceData.RejionerWithoutCrewWelfare,
        creatorId: creatorId, // Ensure this is set correctly
      };

      const token = localStorage.getItem("token"); 

      const response = await axios.post(`${baseURL}/api/createChargesForCrewingAgent`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      
      alert("Charges created successfully!");

      // Close the modal after submission
      handleCloseModal();

    } catch (error) {
      console.error("Error creating charges:", error.response?.data || error.message);
      alert("Failed to create charges. Please try again.");
    }
  };


  const filteredAgents = crewingAgents
    .filter((agent) =>
      agent.agentName.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.agentName.localeCompare(b.agentName));

  const handleOpenBankModal = (agentId) => {
    setSelectedAgent(agentId);
    setOpenBankModal(true);
  };



  const handleCloseBankModal = () => {
    setOpenBankModal(false);
    setBankDetails({
      bankName: '',
      accountNumber: '',
      ifscCode: '',
      branchName: '',
      bankAdress: '',
    });
  };

  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleBankSubmit = async () => {
    

    const payload = {
      crewingAgentId: selectedAgent,
      accountNumber: bankDetails.accountNumber,
      bankName: bankDetails.bankName,
      ifscCode: bankDetails.ifscCode,
      branchName: bankDetails.branchName,
      bankAdress: bankDetails.bankAdress,
      BankHolderName: bankDetails.BankHolderName,
    }

    try {
      const token = localStorage.getItem("token");
      const bankDetails = await axios.post(`${baseURL}/api/CrewinngAccount/CrewingAgentAccount`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      alert("data saved succesfully")
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (err) {
      // console.log(err)
    }


  }


  return (
    <>
      <Navbar />
      <div style={{ padding: '24px' }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <TextField
            label="Search by Name"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: '300px' }}
          />
          <Typography variant="h4" sx={{ flexGrow: 1, textAlign: "center", mr: "300px" }}>
            Crewing Agents List
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#C30B12", height: "30px", "& th": { color: "white", fontWeight: "bold" } }}>
              <TableRow>
                <TableCell><strong>Sr. No.</strong></TableCell>
                <TableCell><strong>Name</strong></TableCell>
                <TableCell><strong>Email</strong></TableCell>
                <TableCell><strong>Short Name</strong></TableCell>
                <TableCell><strong>Actions</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAgents
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((agent, index) => (
                  <TableRow key={agent._id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{agent.agentName}</TableCell>
                    <TableCell>{agent.email}</TableCell>
                    <TableCell>{agent.shortName}</TableCell>
                    <TableCell>
                      <Tooltip title="View Details">
                        <IconButton onClick={() => navigate(`/crew-agent/${agent._id}`)}>
                          <VisibilityIcon sx={{color:"#C30B12"}} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Charges">
                        <IconButton onClick={() => handleOpenModal(agent._id)} color="primary">
                          <MonetizationOnIcon  sx= {{color: "#b8860b"}}/>
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Bank Details">
                        <IconButton onClick={() => handleOpenBankModal(agent._id)} color="secondary">
                          <AccountBalanceIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              {filteredAgents.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No matching records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredAgents.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </div>

      {/* Modal for Invoice Input */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="sm" >
        <DialogTitle>Enter Contract Charges</DialogTitle>
        <DialogContent>
          <Box sx={{ width: "400px" }}>  {/* Restrict width inside the modal */}
            <TextField
              label="New Joiner (With Crew Welfare)"
              variant="outlined"
              fullWidth
              margin="dense"
              name="JoinerWithCrewWelfare"
              value={invoiceData.JoinerWithCrewWelfare}
              onChange={handleInputChange}
            />
            <TextField
              label="Rejoiner (With Crew Welfare)"
              variant="outlined"
              fullWidth
              margin="dense"
              name="RejionerWithCrewWelfare"
              value={invoiceData.RejionerWithCrewWelfare}
              onChange={handleInputChange}
            />
            <TextField
              label="New Joiner (Without Crew Welfare)"
              variant="outlined"
              fullWidth
              margin="dense"
              name="JoinerWithoutCrewWelfare"
              value={invoiceData.JoinerWithoutCrewWelfare}
              onChange={handleInputChange}
            />
            <TextField
              label="Rejoiner (Without Crew Welfare)"
              variant="outlined"
              fullWidth
              margin="dense"
              name="RejionerWithoutCrewWelfare"
              value={invoiceData.RejionerWithoutCrewWelfare}
              onChange={handleInputChange}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={
              !invoiceData.JoinerWithCrewWelfare &&
              !invoiceData.RejionerWithCrewWelfare &&
              !invoiceData.JoinerWithoutCrewWelfare &&
              !invoiceData.RejionerWithoutCrewWelfare
            }
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bank Details Modal */}
      <Dialog open={openBankModal} onClose={handleCloseBankModal} maxWidth="sm">
        <DialogTitle>Enter Bank Details</DialogTitle>
        <DialogContent>
          <TextField label="Bank Name" fullWidth margin="dense" name="bankName" value={bankDetails.bankName} onChange={handleBankInputChange} />
          <TextField label="Account Holder Name" fullWidth margin="dense" name="BankHolderName" value={bankDetails.BankHolderName} onChange={handleBankInputChange} />
          <TextField label="Account Number" fullWidth margin="dense" name="accountNumber" value={bankDetails.accountNumber} onChange={handleBankInputChange} />
          <TextField label="IFSC" fullWidth margin="dense" name="ifscCode" value={bankDetails.ifscCode} onChange={handleBankInputChange} />
          <TextField label="Branch" fullWidth margin="dense" name="branchName" value={bankDetails.branchName} onChange={handleBankInputChange} />
          <TextField label="Bank Address" fullWidth margin="dense" name="bankAdress" value={bankDetails.bankAdress} onChange={handleBankInputChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBankModal}>Cancel</Button>
          <Button onClick={handleBankSubmit} variant="contained" color="primary">Submit</Button>
        </DialogActions>
      </Dialog>


    </>
  );
};

export default AllAdminCrewing;
